import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65d544db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layer-controls-ct" }
const _hoisted_2 = { class: "list-header-ct" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Layers", -1))
const _hoisted_4 = { class: "layer-toggle-list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "layer-toggle-item-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "divider" }, null, -1))
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "layer-toggle-item-title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "divider" }, null, -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "layer-toggle-item-title" }

import { useLayers } from '@/states/layerStats';


export default /*#__PURE__*/_defineComponent({
  __name: 'LayerToggleCard',
  emits: ['onClose'],
  setup(__props, { emit }) {


const { menu, activeLayers, toggleLayer } = useLayers();

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('onClose'))),
        class: "p-2 text-gray-400 hover:bg-gray-100 rounded-full absolute right-3 self-center"
      }, [
        _createVNode(_component_Icon, {
          class: "",
          icon: "mdi:close"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu).global, ([key, data]) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "layer-toggle-item-ct",
          onClick: ($event: any) => (_unref(toggleLayer)(key))
        }, [
          _createVNode(_component_v_tooltip, {
            text: _unref(activeLayers).has(key) ? 'Hide Layer' : 'Show Layer',
            location: "left"
          }, {
            activator: _withCtx(({ props }) => [
              (_unref(activeLayers).has(key))
                ? (_openBlock(), _createBlock(_component_Icon, _mergeProps({ key: 0 }, props, {
                    class: "checkbox-icon checked",
                    icon: "mdi:checkbox-marked"
                  }), null, 16))
                : (_openBlock(), _createBlock(_component_Icon, _mergeProps({ key: 1 }, props, {
                    class: "checkbox-icon",
                    icon: "mdi:checkbox-blank-outline"
                  }), null, 16))
            ]),
            _: 2
          }, 1032, ["text"]),
          _createElementVNode("span", _hoisted_6, _toDisplayString(data.label), 1)
        ], 8, _hoisted_5))
      }), 256)),
      _hoisted_7,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu).india, ([key, data]) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "layer-toggle-item-ct",
          onClick: ($event: any) => (_unref(toggleLayer)(key))
        }, [
          _createVNode(_component_v_tooltip, {
            text: _unref(activeLayers).has(key) ? 'Hide Layer' : 'Show Layer',
            location: "left"
          }, {
            activator: _withCtx(({ props }) => [
              (_unref(activeLayers).has(key))
                ? (_openBlock(), _createBlock(_component_Icon, _mergeProps({ key: 0 }, props, {
                    class: "checkbox-icon checked",
                    icon: "mdi:checkbox-marked"
                  }), null, 16))
                : (_openBlock(), _createBlock(_component_Icon, _mergeProps({ key: 1 }, props, {
                    class: "checkbox-icon",
                    icon: "mdi:checkbox-blank-outline"
                  }), null, 16))
            ]),
            _: 2
          }, 1032, ["text"]),
          _createElementVNode("span", _hoisted_9, _toDisplayString(data.label), 1)
        ], 8, _hoisted_8))
      }), 256)),
      _hoisted_10,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu).usa, ([key, data]) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "layer-toggle-item-ct",
          onClick: ($event: any) => (_unref(toggleLayer)(key))
        }, [
          _createVNode(_component_v_tooltip, {
            text: _unref(activeLayers).has(key) ? 'Hide Layer' : 'Show Layer',
            location: "left"
          }, {
            activator: _withCtx(({ props }) => [
              (_unref(activeLayers).has(key))
                ? (_openBlock(), _createBlock(_component_Icon, _mergeProps({ key: 0 }, props, {
                    class: "checkbox-icon checked",
                    icon: "mdi:checkbox-marked"
                  }), null, 16))
                : (_openBlock(), _createBlock(_component_Icon, _mergeProps({ key: 1 }, props, {
                    class: "checkbox-icon",
                    icon: "mdi:checkbox-blank-outline"
                  }), null, 16))
            ]),
            _: 2
          }, 1032, ["text"]),
          _createElementVNode("span", _hoisted_12, _toDisplayString(data.label), 1)
        ], 8, _hoisted_11))
      }), 256))
    ])
  ]))
}
}

})